<template>
<div class="container" style="width: 60vw">
    <p class="uk-text-center"><span v-if="message" class="uk-text-small uk-text-light" :class="message.type">{{message.text}}</span></p>
    <p class="uk-align-right">
            <ul class="uk-iconnav">
                <li><a href="" uk-icon="icon: mail; ratio: 2" uk-tooltip="Send to mail" @click.prevent="sendPdfToEmail()" class="email"></a></li>
                <li><a uk-icon="icon: file-pdf; ratio: 2" uk-tooltip="Download pdf file" @click.prevent="generatePdf()" class="pdf"></a></li>
                <li><a uk-icon="icon: comment; ratio: 2" uk-tooltip="Leave a comment" @click.prevent="showComment = true" class="comment"></a></li>
            </ul>
    </p>
    <div uk-grid style="width: 100%" v-show="showComment">
        <div class="uk-width-expand@m">
            <div class="uk-margin">
                <textarea class="uk-textarea" rows="3" v-model="comment"></textarea>
            </div>
        </div>
        <div class="uk-width-auto@m uk-align-center">
            <ul class="uk-iconnav">
                <li><a href="" uk-icon="icon: check" uk-tooltip="Send comment" @click.prevent="sendComment(); showComment = false"></a></li>
                <li><a href="" uk-icon="icon: close" uk-tooltip="Close" @click.prevent="showComment = false"></a></li>
            </ul>
        </div>      
    </div>
    <template v-if="type === 'Radar'">
        <div ref="content">
            <h2>{{firstName}} {{lastName}}</h2>
            <h3>Natural Genius Profile: <span class="result">{{profileResult}}</span></h3>
            <table class="uk-table uk-table-small uk-table-divider" style="width: 700px">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Count</th>
                        <th>%</th>
                    </tr>
                </thead>
                <tfoot>
                    <tr>
                        <td>Total</td>
                        <td>{{sum(tableData, 'value')}}</td>
                        <td>{{sum(tableData, 'percent')}}</td>
                    </tr>
                </tfoot>
                <tbody>
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>{{item.title}}</td>
                        <td>{{item.value}}</td>
                        <td>{{item.percent}}</td>
                    </tr>
                </tbody>
            </table>
            <radar :stats="visualData"></radar>
            <div class="uk-padding uk-width-1-1@m uk-text-center">
                <button class="uk-button uk-button-primary uk-button-large"  @click.prevent="startAssessment('5f9b7628117c94093557f389')">Continue with the second part of the assessment</button>
            </div>
        </div>
    </template>
    <template v-if="type === 'Energy'">
        <div ref="content">
            <h2>{{firstName}} {{lastName}}</h2>
            <h3>
                Current Conscioussness Profile<br/>
                Core Level: <span class="result">{{profileResult}}</span></h3>
            <table class="uk-table uk-table-small uk-table-divider" style="width: 700px">
                <thead>
                    <tr>
                        <th>N</th>
                        <th>Name</th>
                        <th>%</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>{{item.level}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.percent}}</td>
                    </tr>
                </tbody>
            </table>
            <h3 class="uk-text-center result">Your Consciousness Average: {{average}}</h3>
            <div class="v-energy">
                <div class="chars" ref="chars">
                    <energy v-for="(item, index) in visualData" :text-inside="true" :stroke-width="25" :percentage="item.percent" color="rgba(33, 108, 178, 1)" :key="index"></energy>
                </div>
            </div>
        </div>
    </template>
    <div id="modal-sections" uk-modal>
    <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-body">
           <h3>Send results by email</h3>
        </div>
        <div class="uk-modal-footer uk-text-right">
            <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>
            <button class="uk-button uk-button-primary" type="button" @click="hideModalSendForm()">Yes</button>
        </div>
    </div>
</div>
</div>
</template>

<script>
import ChartRadar from '@/components/ChartRadar';
import ProgressEnergy from '@/components/ProgressEnergy';
import CompletedService from '@/services/completed.service';
export default {
    name: 'CompletedAssessment',
    components: {
        'radar': ChartRadar,
        'energy': ProgressEnergy
    },
    data() {
        return {
            id: '',
            type: '',
            profileResult: String,
            visualData: Array,
            tableData: Array,
            average: String,
            message: '',
            comment: '',
            showComment: false,
            firstName: '',
            lastName: '',
            sendF: null,
            messageF: '',
            countSend: 0
        }
    },
    created() {
        if(this.$route.params.id === undefined) {
            this.$router.push({name: "dashboard"});
        } else {
            this.id = this.$route.params.id;
            this.getCompleted(this.$route.params.id);
            
        }
        setInterval(() => {
            this.message = null;
        }, 10000)
    },
    mounted() {
        this.showModalSendForm();
    },
    methods: {
        sum(items, prop){
            return items.reduce( function(a, b){
                return a + b[prop];
            }, 0);
        },
        getCompleted(id) {
            CompletedService.one(id).then(
                    res => {
                        this.type = res.data.type;
                        this.profileResult = res.data.profileResult;
                        this.tableData = res.data.tableData;
                        this.visualData = res.data.visualData;
                        this.firstName = res.data.firstName;
                        this.lastName = res.data.lastName;
                        if(res.data.average)
                            this.average = res.data.average;
                        
                        this.message = {text: res.data.message, type: 'uk-text-success'};
                    },
                    error => {
                        let message = (error.response && error.response.data.message.message) || error.message || error.toString();
                        this.message = {text: message, type: 'uk-text-danger'}
                    }
                );
        },
        sendComment() {
            CompletedService.update({id: this.id, comment: this.comment}).then(
                res => {
                    this.message = {text: res.data.message, type: 'uk-text-success'}
                    this.comment = ''
                },
                error => {
                    let message = (error.response && error.response.data.message.message) || error.message || error.toString();
                    this.message = {text: message, type: 'uk-text-danger'}
                }
            );
        },
        sendPdfToEmail() {
            let vm = this;
            let pdfName = this.id;
            const formData = new FormData();
            let chart = document.getElementById('chart');
            if (chart) {
                let xml = (new XMLSerializer()).serializeToString(chart);

                formData.append('id', pdfName);
                formData.append('file', xml)
            } else {
                formData.append('id', pdfName);
            }
            CompletedService.sendPdfToEmail(formData).then(
                res => {
                       vm.message = {text: res.data.message, type: 'uk-text-success'};
                       vm.uk.modal(vm.sendF).hide();
                    },
                    error => {
                        let message = 'Error send email';
                        if(vm.countSend < 2) {
                            vm.sendPdfToEmail();
                        } else {
                            vm.message = {text: message, type: 'uk-text-danger'};
                        }
            });
        },
        generatePdf () {
            let vm = this;
            let pdfName = this.id;
            const formData = new FormData();
            let chart = document.getElementById('chart');
            if (chart) {
                let xml = (new XMLSerializer()).serializeToString(chart);

                formData.append('id', pdfName);
                formData.append('file', xml)
            } else {
                formData.append('id', pdfName);
            }
            CompletedService.generatePdf(formData).then(
                res => {
                    let fileName = this.firstName + '_' + this.lastName + '_' + 'Assessment_' + new Date().toDateString().replace(' ', '_');
                    this.downloadFile(res, fileName)
                },
                error => {
                    let message = (error.response && error.response.data.message.message) || error.message || error.toString();
                    vm.message = {text: message, type: 'uk-text-danger'}
            });
        },
        downloadFile(response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {type: 'application/pdf'})

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob)
                return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob)
            var link = document.createElement('a')
            link.href = data
            link.download = filename + '.pdf'
            link.click()
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data)
            }, 100)
        },
        startAssessment(id) {
             this.$router.push({ name: 'assessment.start', params: { id: id } });
        },
        showModalSendForm() {
            if(document.getElementById("modal-sections")) {
                let element = document.getElementById('modal-sections');
                this.uk.modal(element).show();
                this.sendF = element;
            }

        },
        hideModalSendForm() {
            this.sendPdfToEmail();
        }
    },
}
</script>

<style>
.result {
    color: #f4951b;
    font-weight: bold;
}
.uk-iconnav {
    position: fixed;
    border: 1px dashed #f4951b;
    padding: 10px;
    border-radius: 40px;
    z-index: 1000;
}
.uk-iconnav a.uk-icon.email{
    color: #f41b63;
}
.uk-iconnav a.uk-icon.pdf{
    color: #116315;
}
.uk-iconnav a.uk-icon.comment{
    color: #0043A4;
}
</style>